export const inviteAFriend = {
  flourish: {
    alt: "Design flourish",
  },
  inviter: {
    dashboard: {
      copy: "Copy referral link",
      heading: "Refer-a-Friend: Give 10% off, get 10% off!",
      subheading:
        "Copy the link below and share it with your friends to give them 10% off their first month of Conceive. As a thank you, you’ll get 10% off the month they join!",
    },
    page: {
      cta: "Copy your referral link",
      content:
        "Copy the link below and share it with your friends to give them 10% off their first month of Conceive. As a thank you, you’ll get 10% off the month they join!",
      heading: "Give 10% off, get 10% off!",
      title: "Refer-a-Friend",
    },
    tooltip: "Copied to clipboard!",
  },
  invitee: {
    heading: "Refer-a-Friend",
    membershipPayment: {
      alert:
        "Your Refer-a-Friend offer is applied so you’ll get <Strong>10% off your first month!</Strong>",
      legalese:
        "Cancel anytime. You will be charged the regular subscription price after your first month. New members only.",
    },
    membershipSelect: {
      alert:
        "Your Refer-a-Friend offer is applied so you’ll get 10% off your first month, whichever plan you choose!",
    },
    planPayment: {
      alert:
        "Your Refer-a-Friend offer is applied so you’ll get <Strong>10% off your first month!</Strong>",
      legalese:
        "Cancel anytime. You will be charged the regular subscription price after your first month. New members only.",
    },
    planSelect: {
      alert:
        "Your Refer-a-Friend offer is applied so you’ll also get <strong>10% off your first month</strong>",
    },
    signUp: {
      title: "Sign up now to get 10% off your first month!",
    },
    welcome: {
      title: "Sign up now to get <br/> 10% off your first month!",
    },
  },
};
